import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import React, {ReactNode} from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import {Divider, useTheme} from "@material-ui/core";
import FlexBox from "view/components/Layout/FlexBox";
import FfairTooltip from "view/components/Layout/Tooltip";
import {useSelector} from "react-redux";
import {selectUser} from "store/auth/selectors";
import useStyles from "./styles";
import ElipsisWrapper from "./ElipsisWrapper";

type Classes = {
  root?: string;
  label?: string;
  value?: string;
  actionPanel?: string;
  icon?: string;
  row?: string;
};

export type DataRowProps = {
  label: React.ReactNode;
  value: ReactNode;
  classes?: Classes;
  last?: boolean;
  disabled?: boolean;
  icon?: ReactNode;
  textColor?: string;
  actionPanel?: ReactNode;
  customWidth?: string;
  onClickRoot?: () => void;
  tooltipText?: string;
  interlineItem?: ReactNode;
  tooltipPosition?: "start" | "end";
};

const DataRow: React.FC<DataRowProps> = ({
  label,
  value,
  classes: propsClasses,
  last,
  icon,
  disabled,
  textColor,
  actionPanel,
  customWidth,
  onClickRoot,
  tooltipText,
  tooltipPosition,
  interlineItem,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const user = useSelector(selectUser);
  return (
    <FlexBox column style={{width: customWidth || "unset"}}>
      <Box
        className={clsx(
          classes.box,
          propsClasses?.root,
          disabled && classes.disabledBox
        )}
        style={{width: customWidth || "unset"}}
        onClick={onClickRoot}
      >
        {icon && (
          <div className={clsx(classes.icon, propsClasses?.icon)}>{icon}</div>
        )}
        <div className={clsx(classes.row, propsClasses?.row)}>
          <Typography
            variant="body2"
            className={clsx(
              classes.label,
              propsClasses?.label,
              classes.overflowHidden
            )}
          >
            {tooltipPosition === "start" && tooltipText && (
              <FfairTooltip title={tooltipText} placement="top" arrow>
                <InfoOutlinedIcon className={classes.infoIcon} />
              </FfairTooltip>
            )}

            {label}

            {tooltipPosition !== "start" && tooltipText && (
              <FfairTooltip title={tooltipText} placement="top" arrow>
                <InfoOutlinedIcon className={classes.infoIcon} />
              </FfairTooltip>
            )}
          </Typography>
          <Typography
            variant="body2"
            className={clsx(
              classes.value,
              classes.overflowHidden,
              propsClasses?.value
            )}
          >
            <ElipsisWrapper
              value={value}
              textColor={
                textColor ||
                (user.role === "exhibitor"
                  ? theme.palette.contrastText.main
                  : "#000")
              }
            />
          </Typography>
          {actionPanel ? (
            <div
              className={clsx(classes.actionPanel, propsClasses?.actionPanel)}
            >
              {actionPanel}
            </div>
          ) : (
            <div />
          )}
        </div>
      </Box>
      {!last && (
        <FlexBox width="100%" alignCenter gap={2}>
          <Divider className={classes.divider} />
          <FlexBox alignCenter justifyContent="end">
            {interlineItem || null}
          </FlexBox>
        </FlexBox>
      )}
    </FlexBox>
  );
};

export default DataRow;
